import { axiosGet } from '@/api/handlers';
import { ExpenditureBudgetPurposeModel } from '../models';

export const fetchExpenditureBudgetPurpose = async (id: string) => {
  const res = await axiosGet(`/api/expenditure-budget-purposes/${id}/`);
  return ExpenditureBudgetPurposeModel.parse(res);
};
